import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {SocialTemplateStyle} from './../../styles'
import {
  Facebook,
  Twitter,
  Instagram,
  Linkedin,
  Weibo,
  Desktop,
} from './..'

export default class SocialTemplate extends Component {
  state = {

  }

  getIcons = (type) => {
    let nComponent = null
    switch (type) {
      case 'instagram':
        nComponent = <Instagram width={24} height={24} />
        break;
      case 'facebook':
        nComponent = <Facebook width={24} height={24} />
        break;
      case 'twitter':
        nComponent = <Twitter width={24} height={24} />
        break;
      case 'linkedin':
        nComponent = <Linkedin width={24} height={24} />
        break;
      case 'weibo':
        nComponent = <Weibo width={24} height={24} />
        break;
      case 'desktop':
        nComponent = <Desktop width={24} height={24} />
        break;
    
      default:
        break;
    }

    return nComponent
  }
  
  render() {
    const { items, title, picture } = this.props
    return (
      <div className={`product-template product-template--videos ${SocialTemplateStyle(picture)}`}>
        <div className="template-scroll flex">
          <div className="template-left" ></div>
          <div className="template-right template-content">
            <h2 className="subtitle"> { title } </h2>
            <div className="social-container">
            {
                items.map((social, index) => (
                  <div className="social-row flex items-center" key={index}>
                    <span className="social-svg">
                      {
                        this.getIcons(social.type)
                      }
                    </span>
                    <span className="social-label"> { social.label } : </span>
                    <a href={social.link} target="_blank">
                      <span className="link"> { social.link } </span>
                    </a> 
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/SocialTemplate.js